import { render, staticRenderFns } from "./AdminPackageManagment.vue?vue&type=template&id=a7897bfa&"
import script from "./AdminPackageManagment.vue?vue&type=script&lang=js&"
export * from "./AdminPackageManagment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports